import {
    UPDATE_ALERTS,
    UPDATE_SUBSCRIPTION,
    UPDATE_WIDGETS_WITH_ALARMS,
    UPDATE_MUTED_WIDGETS,
    CLEAR_ALARMS,
    HIGHEST_SEVERITY,
    SECOND_HIGHEST_SEVERITY,
    QUERY_STOPPED
} from '../constants'

const dashboardInitialState = () => ({
    batch: [],
    mutedWidgets: {},
    queryStopped: false,
    subscription: null,
    widgetsWithAlarms: {}
})

export default function dashboardReducer(state = dashboardInitialState(), action) {
    if (!action?.type) return state

    switch (action.type) {
        case CLEAR_ALARMS:
            return {
                ...state,
                batch: [],
                widgetsWithAlarms: {},
                mutedWidgets: {}
            }
        case QUERY_STOPPED:
            return {
                ...state,
                queryStopped: true
            }
        case UPDATE_ALERTS:
            return {
                ...state,
                batch: action.batch,
                queryStopped: false
            }
        case UPDATE_MUTED_WIDGETS:
            return {
                ...state,
                mutedWidgets: {
                    ...state.mutedWidgets,
                    ...action.widgets
                }
            }
        case UPDATE_SUBSCRIPTION:
            return {
                ...state,
                subscription: action.subscription,
                queryStopped: false
            }
        case UPDATE_WIDGETS_WITH_ALARMS:
            if (!action.remove) {
                const widget = state.widgetsWithAlarms[action.widgetId] || {}
                const existingAlarms = widget[action.channel] || []
                const alarmsMappedByRule = {}
                action.alarms.forEach(alarm => {
                    const id = alarm.latestTrigger?.alarm?.ref?.ruleId || alarm.ref.ruleId

                    if (!alarmsMappedByRule[id]) {
                        alarmsMappedByRule[id] = alarm
                    }

                    const prev = existingAlarms.find(existingAlarm => existingAlarm.id === alarm.id)
                    // if they are the same then no need to check
                    if (!prev || prev.lastUpdatedAt !== alarm.lastUpdatedAt || prev.totalEvents !== alarm.totalEvents) {
                        const newAlarm =
                            !prev || (prev.severity === SECOND_HIGHEST_SEVERITY && alarm.severity === HIGHEST_SEVERITY)
                        alarmsMappedByRule[id].new = newAlarm
                    }
                })

                return {
                    ...state,
                    widgetsWithAlarms: {
                        ...state.widgetsWithAlarms,
                        [action.widgetId]: {
                            ...widget,
                            [action.channel]: Object.keys(alarmsMappedByRule).map(id => alarmsMappedByRule[id])
                        }
                    }
                }
            }

            return {
                ...state,
                widgetsWithAlarms: Object.keys(state.widgetsWithAlarms).reduce((obj, widgetId) => {
                    const currentWidget = state.widgetsWithAlarms[widgetId] || {}
                    const widget = Object.keys(currentWidget).reduce(
                        (newMap, channel) => ({
                            ...newMap,
                            ...(channel === action.channel ? {} : { [channel]: currentWidget[channel] })
                        }),
                        {}
                    )

                    return {
                        ...obj,
                        [widgetId]: widget
                    }
                }, {})
            }
        default:
            return state
    }
}
